import React, { useState, useEffect } from 'react';
import { Toast } from 'react-bootstrap';

import Init from '../../../Init/Init';

import './Toast.scss';

const CustomToast = (props) => {
    const { FontAwesomeIcon } = Init;

    const [content, setContent] = useState({
        image: '',
        title: '',
        text: '',
        status: null, // 0: Failed; 1: Success, 2: Info
        show: false,
        position: props.position
    });

    const contentStatusClass = () => {
        switch (content.status) {
            case 0:
                return 'icon-failed';
            case 1:
                return 'icon-success';
            case 2:
                return 'icon-info';
            default:
                return 'icon-failed';
        }
    }

    const contentStatusIcon = () => {
        switch (content.status) {
            case 0:
                return 'times-circle';
            case 1:
                return 'check-circle';
            case 2:
                return 'info-circle';
            default:
                return 'times-circle';
        }
    }

    useEffect(() => {
        let toastData = {};

        if (props.show) {
            toastData = {
                title: props.title,
                status: props.status,
                image: props.image,
                show: true
            };
        } else {
            toastData = {
                title: '',
                status: '',
                image: '',
                show: false
            };
        }

        setContent({
            ...toastData
        });
    }, [props.show, props.children]);

    const close = () => {
        props.onClose();
    }

    return (
        <Toast className={`general-toast ${props.toastClass}`} position={content.position} show={content.show} onClose={close}>
            <Toast.Header className='general-toast-header'>
                <FontAwesomeIcon className={`${contentStatusClass()}`} icon={['fas', contentStatusIcon()]} />  <span className="general-toast-title">{content.title}</span>
                {/* <small>11 mins ago</small> */}
            </Toast.Header>
            <Toast.Body className={`general-toast-body ${props.customClass}`}>
                {props.children}
            </Toast.Body>
        </Toast>
    );
}

CustomToast.defaultProps = {
    title: '',
    status: null,
    show: false,
    toastClass: '',
    customClass: '',
    position: 'top-end'
};

export default CustomToast;